import { getStyle } from "../../hooks/use-styles";

const LinkText = ({ text, onClick, fontClass,fontColor, className }) => {
  return (
    <div
      className={`${fontClass || "text-sm"} weight-400 pointer ${
        className || ""
      }`}
      onClick={onClick}
      style={{ color: getStyle(fontColor || "primaryColor") }}
    >
      {text}
    </div>
  );
};

export default LinkText;
